module.exports = __webpack_public_path__ + "img/paraguas.faf45a56.jpg";